import { ValidateTransactionResponse } from "@ac-expo/api-types";
import { OrderStatus } from "@prisma/client";

const MAX_POLLING_ATTEMPTS = 6; // 30 seconds total (6 * 5s)
const POLLING_INTERVAL = 5000; // 5 seconds

export async function pollOrderStatus(
  searchParams: string,
  validateTransaction: (
    paramsString: string
  ) => Promise<ValidateTransactionResponse>,
  attempts = 0
) {
  const response = await validateTransaction(searchParams);

  if (
    response.status === OrderStatus.success ||
    response.status === OrderStatus.refused ||
    response.status === OrderStatus.canceled ||
    response.status === OrderStatus.error
  ) {
    return response;
  }

  if (attempts >= MAX_POLLING_ATTEMPTS) {
    throw new Error("Payment validation timeout");
  }

  await new Promise((resolve) => setTimeout(resolve, POLLING_INTERVAL));
  return pollOrderStatus(searchParams, validateTransaction, attempts + 1);
}
